import { CallOverrides } from "ethers";
      /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type PollsContractFunctions1 = [] | [PollsContractFunctions] | [PollsContractFunctions, PollsContractEvents];
export type SWEvent = {
  event: PollsContractEventType;
  args: any;
}[];

export interface PollsContractFunctions {
  close: (
    pollID: number,
    results: string,
    participants: string[],
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<PollsContractEvents>}>;
  create: (_role: number, _dueDate: number, _uri: string, overrides?: CallOverrides) => Promise<number>;
  daoExpander: (overrides?: CallOverrides) => Promise<string>;
  discordBot: (overrides?: CallOverrides) => Promise<string>;
  /**
   * Response type names are:
   *
   * timestamp: number
   * pollData: string
   * results: string
   * isFinalized: boolean
   * role: number
   * dueDate: number
   */
  getById: (id: number, overrides?: CallOverrides) => Promise<[number, string, string, boolean, number, number]>;
  getIDCounter: (overrides?: CallOverrides) => Promise<number>;
}
export interface PollsContractEvents {
  events: SWEvent;
}

export enum PollsContractEventType {
  PollClosed = "PollClosed",
  PollCreated = "PollCreated"
}
